'use client';

import { c as _c } from "react/compiler-runtime";
import { DeploymentLayout } from '@shared/all/domains/spaces';
import { PreferencesEnum } from '@shared/all/domains/user';
import usePreference from '@shared/utils/hooks/usePreference';
import useUser from '@shared/utils/hooks/useUser';
import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { spaceConfig } from '../../utils/getSpaceConfig';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import UsersList from '../profile/UsersList';
import SpacesList from '../spaces/SpacesList';
import { ToggleItem } from '../UI/ToggleItem';
const Preferences = () => {
  const $ = _c(17);
  const {
    currentUser
  } = useUser();
  const {
    preferenceState,
    updatePreferences
  } = usePreference(client);
  const [spaceFilterListModalOpen, setSpaceFilterListModalOpen] = useState(false);
  const [mutedUserModalOpen, setMutedUserModalOpen] = useState(false);
  const [blockedUserModalOpen, setBlockedUserModalOpen] = useState(false);
  let t0;
  if ($[0] !== currentUser.isAuthenticated || $[1] !== preferenceState || $[2] !== updatePreferences) {
    t0 = currentUser.isAuthenticated && <><ToggleItem title="Allow Profanity" description="Obfuscate profanity content in posts and other places." state={preferenceState.allowProfanity} onChange={() => updatePreferences(PreferencesEnum.allowProfanity)} /><ToggleItem title="Show Political Content" description="View posts and content that are tagged as political." state={preferenceState.allowPoliticalContent} onChange={() => updatePreferences(PreferencesEnum.allowPoliticalContent)} /><ToggleItem title="Show NSFW Content" description="View posts and content that are tagged as NSFW. When disabled, NSFW posts are hidden from feeds and NSFW media is blurred." state={preferenceState.allowNSFWContent} onChange={() => updatePreferences(PreferencesEnum.allowNSFWContent)} /><ToggleItem title="Public Beta" description="Enable access to upcoming beta features." state={preferenceState.publicBeta} onChange={() => updatePreferences(PreferencesEnum.publicBeta)} />{!(spaceConfig.layoutType === DeploymentLayout.Space) && <ButtonItem title="Space Filters" description="Spaces you want to use to filter your feeds results." onClick={() => setSpaceFilterListModalOpen(true)} />}<ButtonItem title="Muted Users" description="See a list of all the users that you have muted." onClick={() => setMutedUserModalOpen(true)} /><ButtonItem title="Blocked Users" description="See a list of all the users that you have blocked." onClick={() => setBlockedUserModalOpen(true)} /></>;
    $[0] = currentUser.isAuthenticated;
    $[1] = preferenceState;
    $[2] = updatePreferences;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <div className="flex flex-col items-center space-y-4 p-4">{t0}</div>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== spaceFilterListModalOpen) {
    t2 = spaceFilterListModalOpen && <SpacesList title="Your Filters" closeHandler={() => setSpaceFilterListModalOpen(false)} fetchFunction={_temp} />;
    $[6] = spaceFilterListModalOpen;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== mutedUserModalOpen) {
    t3 = mutedUserModalOpen && <Modal closeHandler={() => setMutedUserModalOpen(false)}><ModalHeader closeHandler={() => setMutedUserModalOpen(false)}><h1>Muted Users</h1></ModalHeader><ModalContent><UsersList title="Muted Users" fetchFunction={_temp2} /></ModalContent></Modal>;
    $[8] = mutedUserModalOpen;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== blockedUserModalOpen) {
    t4 = blockedUserModalOpen && <Modal closeHandler={() => setBlockedUserModalOpen(false)}><ModalHeader closeHandler={() => setBlockedUserModalOpen(false)}><h1>Blocked Users</h1></ModalHeader><ModalContent><UsersList title="Blocked Users" fetchFunction={_temp3} /></ModalContent></Modal>;
    $[10] = blockedUserModalOpen;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export function ButtonItem(t0) {
  const $ = _c(11);
  const {
    title,
    description,
    onClick
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p>{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <span className="mt-3 block text-textSecondary">{description}</span>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><ChevronRight size={25} /></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClick || $[9] !== t3) {
    t5 = <div className="mt-6 flex w-full max-w-[660px] justify-between rounded-md border border-solid border-ds-border-standard p-4 align-middle" onClick={onClick}>{t3}{t4}</div>;
    $[8] = onClick;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export default Preferences;
function _temp(cursor) {
  return client.spaces.filtered.query({
    cursor
  });
}
function _temp2(cursor_0) {
  return client.users.mutedUsers.query({
    cursor: cursor_0
  });
}
function _temp3(cursor_1) {
  return client.users.blockedUsers.query({
    cursor: cursor_1
  });
}